import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/components/Navbar";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-white px-5 grain">
      <div className="w-full max-w-md">
        <img src={LOGO_URL} alt="GAVRA" className="mx-auto h-10 w-auto" />
        <div className="mt-10 border border-black/10 p-8 md:p-10">
          <div className="flex items-center gap-2 text-gavra">
            <Lock className="h-4 w-4" />
            <span className="font-mono-hw text-[11px] uppercase tracking-[0.25em]">Admin Access</span>
          </div>
          <h1 className="mt-3 font-heading text-3xl font-black uppercase tracking-tight">Sign in</h1>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label className="font-mono-hw text-[11px] uppercase tracking-widest text-black/50">Email</label>
              <input
                data-testid="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 h-12 w-full border border-black/20 bg-white px-3 text-base outline-none focus:border-gavra"
                placeholder="admin@gavrahardware.com"
              />
            </div>
            <div>
              <label className="font-mono-hw text-[11px] uppercase tracking-widest text-black/50">Password</label>
              <input
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 h-12 w-full border border-black/20 bg-white px-3 text-base outline-none focus:border-gavra"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <p data-testid="admin-login-error" className="border border-destructive/30 bg-destructive/5 px-3 py-2 text-sm text-destructive">
                {error}
              </p>
            )}
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-black px-8 py-4 text-[13px] font-bold uppercase tracking-[0.15em] text-white transition-colors hover:bg-gavra disabled:opacity-50"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
